import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoginService } from '@delhivery/auth';

/**
 * Single shared logout entry point, used by every "Logout" control in the app
 * (desktop avatar menu, mobile sidebar link, etc.) so they all behave identically.
 *
 * Uses @delhivery/auth's LoginService.signOutOfSession() instead of calling
 * OAuthService.logOut() directly:
 * - it sends the real id_token_hint, which lets Keycloak skip its own
 *   "confirm logout?" page
 * - it clears local/session storage itself and navigates back to the app root
 *
 * redirectUriAsPostLogoutRedirectUriFallback is disabled first because
 * angular-oauth2-oidc defaults it to true, which would otherwise send
 * Keycloak our OIDC login callback URL (/lib-auth-oauth-callback) as
 * post_logout_redirect_uri - a URI Keycloak's client isn't configured to
 * accept for logout, causing an "Invalid redirect uri" error.
 */
@Injectable({ providedIn: 'root' })
export class AppAuthService {
  constructor(
    private oAuthService: OAuthService,
    private loginService: LoginService
  ) { }

  logout(): void {
    this.oAuthService.redirectUriAsPostLogoutRedirectUriFallback = false;
    this.loginService.signOutOfSession();
  }
}
